<script setup lang="ts">
import type { Task } from '~/types/task.type'

defineProps({
  task: {
    type: Object as PropType<Task<undefined>>,
    required: true,
  },
})

defineEmits<{
  close: [boolean]
}>()
</script>

<template>
  <DeleteModal @close="$emit('close', $event)">
    <slot />
    <template #body>
      <div>
        Bist du dir sicher, dass du die Aufgabe <span class="font-semibold">{{ task.name }}</span> löschen möchtest?
      </div>
    </template>
  </DeleteModal>
</template>
